import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { CptCode } from 'src/app/Models/cptcode.model';
import { Doctor } from 'src/app/Models/doctor.model';
import { CptcodeService } from 'src/app/services/cptcode.service';
import { DoctorService } from 'src/app/services/doctor.service';
import { NurseService } from 'src/app/services/nurse.service';
import { PatientService } from 'src/app/services/patient.service';
import { PatientvisitService } from 'src/app/services/patientvisit.service';
import { VoiceRecognitionAssessmentService } from 'src/app/services/voice-recognition-assessment.service';
import { VoiceRecognitionObjectiveService } from 'src/app/services/voice-recognition-objective.service';
import { VoiceRecognitionPlanService } from 'src/app/services/voice-recognition-plan.service';
import { VoiceRecognitionService } from 'src/app/services/voice-recognition.service';

@Component({
  selector: 'app-update-nurse-patient-visit',
  templateUrl: './update-nurse-patient-visit.component.html',
  styleUrls: ['./update-nurse-patient-visit.component.css'],
})
export class UpdateNursePatientVisitComponent implements OnInit {
  cities!: CptCode[];

  selectedCities!: CptCode[];

  id = 0;
  myControl = new FormControl('');
  selectedCPTCodes: string[] = [];
  options: string[] = ['New Patient', 'Follow Up'];
  doctorSpeciality: string[] = [
    'Allergy and Immunology',
    'Anesthesiology',
    'Cardiology',
    'Critical Care Medicine',
    'Colon and Rectal Surgery',
    'Dermatology',
    'Emergency Medicine',
    'Family Medicine',
    'Forensic Pathology',
    'Gastroenterology',
    'General Medicine',
    'Geriatric Medicine',
    'General Surgery',
    'Genetics and Genomics',
    'Hospice and Palliative Medicine',
    'Hospital Medicine',
    'General Internal Medicine',
    'General Surgery',
    'Neurology',
    'Neurological Surgery',
    'Obstetrics and Gynecology',
    'Ophthalmic Surgery',
    'Orthopaedic Surgery',
    'Otolaryngology',
    'Occupational Medicine',
    'Ophthalmology',
    'Orthopedic Surgery',
    'Pathology',
    'Pediatrics',
    'Physical Medicine and Rehabilitation',
    'Plastic Surgery',
    'Preventive Medicine',
    'Psychiatry',
    'Radiology',
    'Respirology',
    'Rheumatology',
    'Sleep Medicine',
    'Thoracic Surgery',
    'Urology',
    'Urology',
    'Cardiovascular Surgery',
    'Spinal Surgeon',
  ];
  doctorList: Doctor[] = [];
  isSuccess = false;
  NurseId: Number;
  helper = new JwtHelperService();
  myToken = window.localStorage.getItem('token');
  cptCodeList: CptCode[] = [];
  @ViewChild('canvas', { static: false }) canvas: ElementRef;
  ctx: CanvasRenderingContext2D;
  brush: any;
  strokes: any[] = [];
  tempStrokesArray: any[] = [];
  currentStroke: any = {};
  currentStrokeIndex: number = 0;
  previousStrokeIndex: number = 0;
  previousStrokeLength: number = 0;
  resultsArray: any[] = [];
  hasUndo: boolean = false;
  undoStrokesArray: any[] = [];
  backwardCount: number = 0;
  drawPadTab = false;
  textTab = true;
  ExportedData = '';
  filteredOptions: Observable<CptCode[]>;
  filteredValues: CptCode[];
  hospitalId: number;
  message: string;
  listening = false;
  listeningObjective = false;
  listeningAssessment = false;
  listeningPatientNote = false;

  subjectiveText: string = '';
  subjectiveTextArr: string[] = [];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private patientVisitService: PatientvisitService,
    private fb: UntypedFormBuilder,
    private doctorService: DoctorService,
    private nurseService: NurseService,
    private cd: ChangeDetectorRef,
    private cptCodeService: CptcodeService,
    private patientService: PatientService,
    public service: VoiceRecognitionService,
    public serviceObjective: VoiceRecognitionObjectiveService,
    public serviceAssessment: VoiceRecognitionAssessmentService,
    public servicePlan: VoiceRecognitionPlanService
  ) {
    this.service.init();
    this.serviceObjective.init();
    this.serviceAssessment.init();
    this.servicePlan.init();
  }

  ngOnInit(): void {
    this.getCptCodes();
    let decodedToken = this.helper.decodeToken(this.myToken);
    this.NurseId = parseInt(decodedToken.nameid);

    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });

    this.getNurse(this.NurseId);

    this.CptCode.valueChanges.subscribe((newValue) => {
      this.filteredValues = this.filterValues(newValue);
    });

    this.patientVisitService.getPatientVisitById(this.id).subscribe((res) => {
      this.addVisitFrm.patchValue(res);
    });
  }
  filterValues(search: string): CptCode[] {
    const filterValue = search.toLowerCase();
    return this.cptCodeList.filter(function (opt) {
      if (opt.Code.includes(filterValue)) {
        return opt;
      }
    });
  }

  addVisitFrm = this.fb.group({
    DoctorName: ['', Validators.required],
    NurseName: [''],
    DoctorSpecialization: ['', Validators.required],
    VisitType: ['', Validators.required],
    VistitDate: ['', Validators.required],
    VistTime: ['', Validators.required],
    PatientNote: [''],
    BloodPressure: [''],
    Pulse: [''],
    CptCode: [''],
    Objective: [''],
    Subjective: [''],
    Assessment: [''],
    NextFollowUp: [''],
    Signature: [''],
  });
  addOption(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.viewValue;
    // console.log('value: ', value);

    if (!this.selectedCPTCodes.includes(value)) {
      this.selectedCPTCodes.push(value);
      this.CptCode.setValue(this.selectedCPTCodes.join(','));
    }
  }
  removeOption(option) {
    const index = this.selectedCPTCodes.indexOf(option);

    if (index >= 0) {
      this.selectedCPTCodes.splice(index, 1);
    }
  }
  get Assessment() {
    return this.addVisitFrm.get('Assessment');
  }
  get Objective() {
    return this.addVisitFrm.get('Objective');
  }
  get Subjective() {
    return this.addVisitFrm.get('Subjective');
  }
  get CptCode() {
    return this.addVisitFrm.get('CptCode');
  }
  get BloodPressure() {
    return this.addVisitFrm.get('BloodPressure');
  }
  get Pulse() {
    return this.addVisitFrm.get('Pulse');
  }
  get Doctor() {
    return this.addVisitFrm.get('DoctorName');
  }
  get NurseName() {
    return this.addVisitFrm.get('NurseName');
  }

  get DoctorSpecialization() {
    return this.addVisitFrm.get('DoctorSpecialization');
  }
  get NextFollowUp() {
    return this.addVisitFrm.get('NextFollowUp');
  }

  get Signature() {
    return this.addVisitFrm.get('Signature');
  }
  // get RoomNo(){
  //   return this.addVisitFrm.get('RoomNo')
  // }

  // get DischargeDate(){
  // return this.addVisitFrm.get('DischargeDate')
  // }
  get VisitType() {
    return this.addVisitFrm.get('VisitType');
  }
  get VistitDate() {
    return this.addVisitFrm.get('VistitDate');
  }
  get VistTime() {
    return this.addVisitFrm.get('VistTime');
  }
  // get ConsultationFee(){
  // return this.addVisitFrm.get('ConsultationFee')
  // }
  // get PatientComplaints(){
  // return this.addVisitFrm.get('PatientComplaints')
  // }
  // get IssueStartDate(){
  // return this.addVisitFrm.get('IssueStartDate')
  // }
  // get Dignosis(){
  // return this.addVisitFrm.get('Dignosis')
  // }
  // get Findings(){
  // return this.addVisitFrm.get('Findings')
  // }
  // get Treatments(){
  // return this.addVisitFrm.get('Treatments')
  // }
  get PatientNote() {
    return this.addVisitFrm.get('PatientNote');
  }
  // get AdmissionDate(){
  //   return this.addVisitFrm.get('AdmissionDate')
  // }

  getNurse(id) {
    this.nurseService.getNurseById(id).subscribe((res) => {
      this.NurseName.setValue(res.NurseName);
    });
  }

  getCptCodes() {
    this.cptCodeService.getCptCodes().subscribe((res) => {
      this.cptCodeList = res;
    });
    // this.http.get('https://binsera.com/dload/ICD_Code.json').subscribe(res =>{
    //   console.log("res", res)
    // })
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    // this.cptCodeList.filter = filterValue.trim().toLowerCase();
  }
  startService() {
    this.service.start();
    this.listening = true;
  }

  stopService() {
    this.service.stop();
    this.listening = false;
  }

  onSubjectiveChange(e) {
    this.service.message1 = e.target.value;
  }

  onSubjectiveBlur() {
    this.stopService();
    this.stopServiceObjective();
    this.stopServiceAssessment();
  }
  onObjectiveBlur() {
    this.stopService();
    this.stopServiceObjective();
    this.stopServiceAssessment();
  }

  onAssessmentBlur() {
    this.stopService();
    this.stopServiceObjective();
    this.stopServiceAssessment();
  }
  onPatientNoteBlur() {
    this.stopService();
    this.stopServiceObjective();
    this.stopServiceAssessment();
  }

  startServiceObjective() {
    this.serviceObjective.startObjective();
    this.listeningObjective = true;
  }
  stopServiceObjective() {
    this.serviceObjective.stopObjective();
    this.listeningObjective = false;
  }

  onObjectiveChange(e) {
    this.serviceObjective.Objective = e.target.value;
  }

  startServiceAssessment() {
    this.serviceAssessment.startAssessment();
    this.listeningAssessment = true;
  }
  stopServiceAssessment() {
    this.serviceAssessment.stopAssessment();
    this.listeningAssessment = false;
  }
  onAssessmentChange(e) {
    this.serviceAssessment.Assessment = e.target.value;
  }
  onPatientNoteChange(e) {
    this.servicePlan.PatientNote = e.target.value;
  }
  startServicePatientNote() {
    this.servicePlan.startPatientNote();
    this.listeningPatientNote = true;
  }
  stopServicePatientNote() {
    this.servicePlan.stopPatientNote();
    this.listeningPatientNote = false;
  }
  formSubmit() {
    let doctorName = this.addVisitFrm.value['DoctorName'];
    let nurseName = this.addVisitFrm.value['NurseName'];
    let doctorSpecialization = this.addVisitFrm.value['DoctorSpecialization'];

    let visitType = this.addVisitFrm.value['VisitType'];
    let vistitDate = this.addVisitFrm.value['VistitDate'];
    vistitDate = moment(vistitDate).format('MM/DD/YYYY');
    let vistTime = this.addVisitFrm.value['VistTime'];

    let patientNote = this.addVisitFrm.value['PatientNote'];
    let bloodPressure = this.addVisitFrm.value['BloodPressure'];
    let pulse = this.addVisitFrm.value['Pulse'];
    let cptCode = this.addVisitFrm.value['CptCode'];
    let objective = this.addVisitFrm.value['Objective'];
    let subjective = this.addVisitFrm.value['Subjective'];
    let assessment = this.addVisitFrm.value['Assessment'];
    let nextFollowUp = this.addVisitFrm.value['NextFollowUp'];
    let signature = this.addVisitFrm.value['Signature'];
    let body = {
      DoctorName: doctorName,
      NurseName: nurseName,
      DoctorSpecialization: doctorSpecialization,
      NurseId: this.NurseId,
      VisitType: visitType,
      VistitDate: vistitDate,
      VistTime: vistTime,
      PatientNote: patientNote.length ? patientNote : this.ExportedData,
      BloodPressure: bloodPressure,
      Pulse: pulse,
      CptCode: cptCode,
      Subjective: subjective,
      Objective: objective,
      Assessment: assessment,
      NextFollowUp: nextFollowUp,
      Signature: signature,
      // SoftwareFee: 2,
    };
    // console.log(body);

    this.patientVisitService
      .updatePatientVisit(this.id, body)
      .subscribe((res) => {
        this.router.navigate(['/nurseDash']);
      });
  }
}
// "RoomNo":roomNo,
// "AdmissionDate":admissionDate,
// "DischargeDate":dischargeDate,

// "ConsultationFee":consultationFee,
// "PatientComplaints":patientComplaints,
// "IssueStartDate":issueStartDate,
//  "Dignosis":dignosis,
//  "Findings":findings,
//  "Treatments":treatments,
